import { useMutation, useQuery } from "react-query";
import { MedAppApi, ViewRequest } from "../../../../api/medAppApi";
import { Feed } from "../../../../models";


export const useCreateFeed = () => {
    return useMutation({
        mutationFn:  async(data: Record<string, any>) => {
            const formData = new FormData();
            for(let key in data) {
                formData.append(key, data[key])
            }

            const response = await MedAppApi.Instance.createFeed({}, {}, formData);
            if(response.error) {
                throw response.error
            } 
            if(response.code !== 200 && response.code !== 201) {
                throw new Error('Something went wrong')
            }
            const imageurl = response.data!.data.payload!.imageUrl
            const refinedPayload = {...data}
            delete refinedPayload['image']
            refinedPayload.imageUrl = imageurl
            refinedPayload.action =  {type: 'no-action', url: 'no-url'}
            const ans = await MedAppApi.Instance.createModel<Feed>({
                modelName: "feed",
                payload: refinedPayload
            })

            if(ans.error) { 
                throw ans.error
            }            else if(ans.code !== 200 && ans.code !== 201) {
                throw new Error('Something went wrong')
            } else {
                return ans.data!.data!.payload
            }
        },
        mutationKey: 'create-feed',
    })
}

export const useViewFeed = (crieteria: ViewRequest, enabled = true) => {
    return useQuery({
        queryKey: ['view-feed', crieteria.modelId],
        queryFn: async () => {
            const response = await MedAppApi.Instance.viewModel<Feed>(crieteria)
            if(response.error) {
                throw response.error
            } else {
                return response.data?.data.payload
            }
            
        },
        enabled
    })
}

export const useUpdateFeed = () => {

    return useMutation({
        mutationFn:  async (data: {payload: Partial<Feed>, id: number}) => {
           const response = await MedAppApi.Instance.updateModel<Feed>({
                modelName: "feed",
                where: {id: data.id},
                update: data.payload
            })

            if(response.error) {
                throw response.error
            } 
            return response.data?.data.model
        },
        mutationKey: 'update-feed'
    })
}